<template>
  <v-container>
    <v-card class="mx-auto" outlined :loading="loadingComputed" :disabled="loadingComputed" width="80%" max-width="600">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-title class="justify-center">{{ title }}</v-card-title>
        <v-card-text>
          <v-row align="center">
            <v-col cols="12">
              <!--ログイン画面用のstyleにするために、baseのtextboxは使わない-->
              <validation-provider v-slot="{ errors }" :name="$t('ELE0044')" rules="required">
                <v-text-field
                  v-model="userCdComputed"
                  :label="$t('ELE0044')"
                  :error-messages="errors"
                  dense
                  persistent-hint
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12">
              <!--ログイン画面用のstyleにするために、baseのtextboxは使わない-->
              <validation-provider v-slot="{ errors }" :name="$t('ELE0155')" rules="required" vid="password">
                <v-text-field
                  autocomplete="new-password"
                  v-model="passwordComputed"
                  :label="$t('ELE0155')"
                  :error-messages="errors"
                  dense
                  :type="show ? 'text' : 'password'"
                >
                  <template v-slot:append>
                    <v-btn icon @click="show = !show" tabindex="-1">
                      <v-icon v-if="show">mdi-eye</v-icon>
                      <v-icon v-else>mdi-eye-off</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-card-actions>
              <btn :label="$t('ELE0342')" :disabled="invalid" depressed @click="submit" />
            </v-card-actions>
          </v-row>
        </v-card-text>
      </validation-observer>
      <system-footer />
    </v-card>
  </v-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Btn from '@/components/atoms/base/button/Btn'
import SystemFooter from '@/components/atoms/base/header-footer/Footer'

export default {
  name: 'SignInForm',

  mixins: [APIUtils, Message],

  components: {
    ValidationObserver,
    ValidationProvider,
    Btn,
    SystemFooter,
  },

  props: {
    userCd: {
      type: String,
      required: true,
    },
    password: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    show: false,
  }),

  computed: {
    title: {
      get() {
        return this.$t('ELE0001') + ' (' + process.env.VUE_APP_STAGE + ')'
      },
    },
    userCdComputed: {
      get() {
        return this.userCd
      },
      set(userCd) {
        this.$emit('update:userCd', userCd)
      },
    },
    passwordComputed: {
      get() {
        return this.password
      },
      set(password) {
        this.$emit('update:password', password)
      },
    },
    loadingComputed: {
      get() {
        return this.loading
      },
      set(loading) {
        this.$emit('update:loading', loading)
      },
    },
  },

  methods: {
    async submit() {
      if (await this.$refs.observer.validate()) {
        this.$emit('submit')
      }
    },
  },
}
</script>
